import { VisionPlan } from "./types";

export const PROVIDERS = ["VSP", "EyeMed", "Davis Vision", "Cigna Vision", "Superior Vision", "Other"];

export const DEFAULT_PLANS: Record<string, VisionPlan> = {
  VSP: {
    provider: "VSP",
    frameAllowance: 150,
    singleVisionCopay: 15,
    bifocalCopay: 15,
    progressiveCopay: 95,
    arCoatingCopay: 0,
    blueLightCopay: null,
    photochromicCopay: null,
    highIndexCopay: null,
    contactAllowance: 150,
    examCopay: 10,
    confidence: "medium",
    notes: ["Standard VSP Signature plan values — paste your plan for accuracy."],
  },
  EyeMed: {
    provider: "EyeMed",
    frameAllowance: 200,
    singleVisionCopay: 0,
    bifocalCopay: 0,
    progressiveCopay: 0,
    arCoatingCopay: 0,
    blueLightCopay: null,
    photochromicCopay: 65,
    highIndexCopay: null,
    contactAllowance: 200,
    examCopay: 0,
    confidence: "medium",
    notes: ["Standard EyeMed Access plan values — paste your plan for accuracy."],
  },
  "Davis Vision": {
    provider: "Davis Vision",
    frameAllowance: 150,
    singleVisionCopay: 0,
    bifocalCopay: 0,
    progressiveCopay: 50,
    arCoatingCopay: 0,
    blueLightCopay: null,
    photochromicCopay: null,
    highIndexCopay: null,
    contactAllowance: 130,
    examCopay: 0,
    confidence: "medium",
    notes: ["Standard Davis Vision plan values — paste your plan for accuracy."],
  },
  "Cigna Vision": {
    provider: "Cigna Vision",
    frameAllowance: 130,
    singleVisionCopay: 10,
    bifocalCopay: 10,
    progressiveCopay: 10,
    arCoatingCopay: null,
    blueLightCopay: null,
    photochromicCopay: null,
    highIndexCopay: null,
    contactAllowance: 130,
    examCopay: 10,
    confidence: "medium",
    notes: ["Standard Cigna Vision plan values — paste your plan for accuracy."],
  },
  "Superior Vision": {
    provider: "Superior Vision",
    frameAllowance: 130,
    singleVisionCopay: 10,
    bifocalCopay: 10,
    progressiveCopay: 50,
    arCoatingCopay: null,
    blueLightCopay: null,
    photochromicCopay: null,
    highIndexCopay: null,
    contactAllowance: 130,
    examCopay: 10,
    confidence: "medium",
    notes: ["Standard Superior Vision plan values — paste your plan for accuracy."],
  },
  Other: {
    provider: "Other",
    frameAllowance: 0,
    singleVisionCopay: 0,
    bifocalCopay: 0,
    progressiveCopay: 0,
    arCoatingCopay: null,
    blueLightCopay: null,
    photochromicCopay: null,
    highIndexCopay: null,
    contactAllowance: 0,
    examCopay: 0,
    confidence: "low",
    notes: ["Paste your plan details so AI can extract your specific benefits."],
  },
};
